import React from "react";

const ModoExclusivo = (props) => {
    return (
        <li>
            <p>{props.data.Descripcion}</p>
        </li>
    );
}

export default ModoExclusivo;